<template>
  <div class="join" :style="{ backgroundImage: `url(${imgUrl})`}"></div>
</template>
<script>
import XHR from '../api'

export default {
  name: 'Join',
  props: [],
  data: () => ({
    imgUrl: ''
  }),
  components: {
  },
  computed: {
    hid: function (params) {
      return this.deviceType === 'pc' ? 4124 : 4121
    }
  },
  created () {
  },
  mounted () {
    this.getHandWork()
  },
  methods: {
    getHandWork () {
      XHR.getHandWork({
        type: 40,
        hid: this.hid
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.imgUrl = data[0].info1
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.join {
  background-repeat: no-repeat;
  background-position: 50% 50%;
  height: 415px;
  width: 375px;
  background-size: cover;
}
@media screen and (min-width: 376px) {
  .join {
    height: 470px;
    background-color: #2e64e4;
    width: 100%;
    margin: auto;
    background-size: auto;
  }
}
</style>
